import React from 'react';
import LoadingView from './LoadingView'
import MainNavigationBar from '../MainNavigationBar'
import Footer from '../Footer'
const LoadingPage = () => {
     return (
         <>
<MainNavigationBar />
<LoadingView />
<Footer />
         </>
     )
}
export default LoadingPage